import React from 'react';
export function SectionDivider() {
  return <div className="flex items-center justify-center py-8" aria-hidden="true" data-id="element-239">
      <div className="h-px w-16 md:w-24 bg-[#B8A068] opacity-50" data-id="element-240"></div>
      <div className="mx-4 w-2 h-2 rounded-full bg-[#B8A068] opacity-70" data-id="element-241"></div>
      <div className="h-px w-16 md:w-24 bg-[#B8A068] opacity-50" data-id="element-242"></div>
    </div>;
}